import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll, ScrollToTop } from "@/components/SmoothScroll";
import { NoiseOverlay } from "@/components/Motion";
import { CustomCursor } from "@/components/CustomCursor";
import { SoundToggle } from "@/components/SoundToggle";
import { LanguageProvider } from "@/i18n/LanguageProvider";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Experiences from "@/pages/Experiences";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ExperienceDetail from "@/pages/ExperienceDetail";
import Staffing from "@/pages/Staffing";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <BrowserRouter>
        <SmoothScroll>
          <div className="evo-fixed-bg" aria-hidden="true" />
          <NoiseOverlay />
          <CustomCursor />
          <SoundToggle />
          <ScrollToTop />
          <Header />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/staffing" element={<Staffing />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/experiences/:id" element={<ExperienceDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: { background: "#0F0F11", border: "1px solid rgba(200,169,126,0.25)", color: "#F4F4F6", borderRadius: 0 },
            }}
          />
        </SmoothScroll>
      </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
